const getPercent = (amount, totalItens) => {
  if(totalItens) {
    return amount / totalItens;
  }

  return 0;
}

export default getPercent;
